export const ADD_HELP_CENTER = 'ADD_HELP_CENTER';
export const GET_HELP_CENTER = 'GET_HELP_CENTER';
export const GET_UNIQUE_HELP_CENTER = 'GET_UNIQUE_HELP_CENTER';
export const EDIT_HELP_CENTER = 'EDIT_HELP_CENTER';
export const DELETE_HELP_CENTER = 'DELETE_HELP_CENTER';